import type { FC } from "react";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useUIStateStore } from "@/store/uiStateStore";

import useDomainConfigAuth from "../api/sanity/queries/getSiteConfigWithDomain";

type FormErrorProps = {
  mutationError?: string;
  validationError?: string;
};

const FormError: FC<FormErrorProps> = (props: FormErrorProps) => {
  const [showError, setShowError] = useState(false);
  const toggleError = () => setShowError(!showError);
  const { mutationError, validationError } = props;
  const { data: domainConfig } = useDomainConfigAuth();
  const supportEmail = domainConfig?.support_email;
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation("security");

  return (
    <>
      {mutationError != null && mutationError.length > 0 && (
        <div className="inline-block w-4/5 p-6 mt-2 mb-8 text-sm text-white bg-red-700 border border-white rounded-lg">
          <p className="mb-4">
            {t("security:mutation-error-message")}
          </p>
          <p>
            {t("security:for-support-prefix")}
            {" "}
            {!isTunecore ? (
              <a
                className="underline"
                href={
                  (supportEmail != null)
                    ? `mailto:${domainConfig?.support_email}`
                    : "mailto:support@sentricmusic.com"
                }
              >
                {(supportEmail != null)
                  ? domainConfig?.support_email
                  : "support@sentricmusic.com"}
              </a>
            ) : (
              <a
                className="underline"
                target="_blank"
                href="https://support.tunecore.com/hc/en-us/requests/new?ticket_form_id=662748"
                rel="noreferrer"
              >
                tunecore.com/support
              </a>
            )}
          </p>
          <button
            type="button"
            onClick={toggleError}
            className="px-4 py-2 mt-4 mb-4 font-bold text-white rounded-lg bg-sentric-rebrand-teal"
          >
            {showError ? t("security:hide-error") : t("security:show-error")}
          </button>
          {showError && <div className="mt-2 text-white">{mutationError}</div>}
        </div>
      )}

      {validationError != null && validationError.length > 0 && (
        <div>
          <p className="inline-block w-4/5 p-6 mt-2 mb-8 text-base text-white bg-red-700 border border-white rounded-lg">
            {validationError}
          </p>
        </div>
      )}
    </>
  );
};

export default FormError;
